exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".widget-editor .histogram .widget-icon {\n  background: url(\"/content/plugin-live-exploratory-viz/histogram-icon.svg\") no-repeat !important;\n  opacity: 1 !important; }\n\n.widget-editor .histogram:hover .widget-icon {\n  filter: brightness(0.7); }\n\n.widget-editor .histogram.active .widget-icon {\n  filter: grayscale(1); }\n", ""]);

